import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useFeature } from '@nextiva/feature-toggle';
import { BULK_IMPORTS } from 'constant';
import { Wayfinder } from '@nextiva/next-ui-wayfinder';
import { dataSelector } from '@nextiva/global-store';
import '@nextiva/next-ui-wayfinder/dist/styles.css';

const SideNav = props => {
  const { isEnabled } = useFeature({
    name: BULK_IMPORTS,
  });

  const routeHandler = linksGroup => {
    return linksGroup.map(group => {
      const links = group.links.map(link => ({
        ...link,
        onClick: () => {
          if (isEnabled && link.label === 'Data import') {
            window.location.href = '/apps/platform-admin/#/data-import';
            return;
          }
          window.location.href = link.defaultRoute;
        },
      }));

      return { ...group, links };
    });
  };

  return (
    !props.isLoading && (
      <Wayfinder
        globalStoreData={props.globalStoreData}
        routeHandler={routeHandler}
      />
    )
  );
};

const mapStateToProps = state => ({
  globalStoreData: dataSelector(state),
});

SideNav.propTypes = {
  globalStoreData: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(SideNav);
